export default function Logo({ className = "h-10 w-auto" }) {
  return (
    <img
      src="/logo.png"
      alt="Joba Construction — Building Today. Building Tomorrow."
      className={className}
    />
  );
}
